import {
  Dropdown,
  IconButton,
  SvgCaretFolder,
  SvgFolder,
  SvgFolderShared,
} from '@loomhq/lens';
import React, { Component } from 'react';

class BreadcrumbsDropdown extends Component {
  render() {
    const { dropdownBreadCrumbs } = this.props;

    const options = dropdownBreadCrumbs.map((crumb, index) => {
      return {
        title: crumb.name,
        icon: crumb.shared ? <SvgFolderShared /> : <SvgFolder />,
        onClick: this.props.onClicked.bind(this, index + 1),
      };
    });

    return (
      <Dropdown
        trigger={<IconButton icon={<SvgCaretFolder />} />}
        options={options}
      />
    );
  }
}

export default BreadcrumbsDropdown;
